import comp from "./TemplateSwitcher";
export default comp;
